export const ICON_SIZES = {
  // array composition is: [width, height]
  xs: [18, 19],
  small: [24, 25],
  medium: [34, 35],
  large: [44, 45],
  xl: [54, 55],
};
